import axios from 'axios';


var backendUrl = 'http://187.77.251.166:21001' // produção
if (window.location.origin == 'http://localhost:3000') {
    backendUrl = 'http://localhost:20000'
} else if (window.location.origin == 'https://apps2.delphus.inf.br') {
    backendUrl = 'https://apps2.delphus.inf.br:20012'
} else if (window.location.origin == 'https://salutesys.com.br') {
    backendUrl = 'https://salutesys.com.br:21002'
}


// console.log(backendUrl)
// console.log(window.location.origin)

const api = axios.create({
    baseURL: backendUrl + `/api/`
});

api.getComboData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        //    console.log('/' + table + '/combo' + (parameter ? '/' + parameter : ''))
        await api.get('/' + table + '/combo' + (parameter ? '/' + parameter : '')).then(async r => {
            resolve(r.data)
        })
    })
}

api.getComboDataWhere = async (table, where) => {
    return new Promise(async (resolve, reject) => {
        await api.get('/' + table + '/combo' + where).then(async r => {
            resolve(r.data)
            
        })
    })
}

api.getComboDataAsync = async (table, setCombo, parameter) => {
    return new Promise(async (resolve, reject) => {
        await api.get('/' + table + '/combo' + (parameter ? '/' + parameter : '')).then(async r => {
            resolve(setCombo(r.data))
        })
    })
}

api.getAcessos = async (tela, opcao) => {
    return new Promise(async (resolve, reject) => {
        let auth = JSON.parse(localStorage['authsalute']);

        await api.get('/grupo_usuarios/permissoes?tela=' + tela + '&pk_usu=' + auth.user + '&acao=' + opcao).then(async r => {
            if (opcao === 'Consulta') {
                try {
                    resolve(r.data[0].Consulta)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Inclusao') {
                try {
                    resolve(r.data[0].Inclusao)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Alteracao') {
                try {
                    resolve(r.data[0].Alteracao)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Exclusao') {
                try {
                    resolve(r.data[0].Exclusao)
                }
                catch { resolve('N') }
            }
        })
    })
}


api.getListData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        await api.get('/' + table + '/lista' + (parameter ? '/' + parameter : '')).then(async r => {
            resolve(r.data)
        })
    })
}


api.noImageUrl = backendUrl + '/static/upload/no-image.jpg'
api.backendUrl = backendUrl

export default api